import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, from, Observable, of } from 'rxjs';
import { concatMap, map, tap, toArray } from 'rxjs/operators';
import * as XLSX from 'xlsx';

import { Animacao } from '../../core/tools/animacao';
import { ClienteService } from '../../core/services/clientes/cliente.service';
import { ConfiguracaoService } from '../../core/services/configuracoes/configuracao.service';
import { ProdutoService } from '../../core/services/produtos/produto.service';
import { VendedorService } from '../../core/services/vendedores/vendedor.service';

import { Cliente } from '../../core/models/clientes/cliente';
import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { Produto } from '../../core/models/produtos/produto';
import { ProdutoCampanha } from '../../core/models/produtos/produto-campanha';
import { ProdutoCampanhaCliente } from '../../core/models/produtos/produto-campanha-cliente';
import { ProdutoCampanhaItens } from '../../core/models/produtos/produto-campanha-itens';
import { ProdutoCampanhaVendedor } from '../../core/models/produtos/produto-campanha-vendedor';
import { ProdutoLote } from '../../core/models/produtos/produto-lote';
import { PromoRegraGrupo } from '../../core/models/produtos/promo-regra-grupo';
import { Vendedor } from '../../core/models/vendedores/vendedor';

export interface FiltroAtivo {
  tipo: string;
  valor: string;
}

interface ImportacaoCampanhaLinha {
  linha: number;
  codigo: string;
  nome: string;
  qtdade: number;
  preco: number | null;
  tipo_calculo: string;
  tipo_percentual: number | null;
  dt_inicio: string;
  dt_fim: string;
  is_active: boolean;
  bonificacao: boolean;
  product_id: number;
  id_lote: number | null;
  price: number;
  erro?: string;
}

@Component({
    selector: 'app-produtos-campanhas-cadastro',
    templateUrl: './produtos-campanhas-cadastro.component.html',
    styleUrls: ['./produtos-campanhas-cadastro.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})
export class ProdutosCampanhasCadastroComponent implements OnInit {
  carregando: boolean = false;
  salvando: boolean = false;

  itemSelecionado: number = 0;
  itemMaximoPermitido: number = 2;

  configuracao: Configuracao | null = null;
  usaPromocao: boolean = false;

  /* Regras de Grupo */
  regrasGrupo: PromoRegraGrupo[] = [];
  regrasGrupoCarregando: boolean = false;
  rgCampoCliente: string = '';
  rgValorCliente: string = '';
  rgValoresCliente: string[] = [];
  rgValoresClienteCarregando: boolean = false;
  rgCampoProduto: string = '';
  rgValorProduto: string = '';
  rgValoresProduto: string[] = [];
  rgValoresProdutoCarregando: boolean = false;
  rgQtdProduto:        number = null;
  rgTipoProduto:       string = '';
  rgPercentualProduto: number = null;

  readonly camposCliente = [
    { campo: 'segment',        label: 'Segmento' },
    { campo: 'classificacao',  label: 'Classificação' },
    { campo: 'ramo_atividade', label: 'Ramo de Atividade' },
    { campo: 'grupo_regiao',   label: 'Grupo Região' },
    { campo: 'subsegmento',    label: 'Subsegmento' },
    { campo: 'subsegmento2',   label: 'Subsegmento 2' },
    { campo: 'tipo_fiscal',    label: 'Tipo Fiscal' },
    { campo: 'rede_postos',    label: 'Rede de Postos' },
  ];

  readonly camposProduto = [
    { campo: 'grupo_estoque',     label: 'Grupo de Estoque' },
    { campo: 'subgrupo_estoque',  label: 'Subgrupo 1' },
    { campo: 'subgrupo_estoque2', label: 'Subgrupo 2' },
    { campo: 'subgrupo_estoque3', label: 'Subgrupo 3' },
    { campo: 'subgrupo_estoque4', label: 'Subgrupo 4' },
    { campo: 'subgrupo_estoque5', label: 'Subgrupo 5' },
  ];

  formProdutoCampanha!: UntypedFormGroup;
  formProdutoCampanhaItem!: UntypedFormGroup;
  formFiltroProduto!: UntypedFormGroup;
  formFiltroCliente!: UntypedFormGroup;
  formFiltroVendedor!: UntypedFormGroup;

  enviadoProdutoCampanha: boolean = false;
  enviadoProdutoCampanhaItem: boolean = false;
  enviadoProduto: boolean = false;
  enviadoCliente: boolean = false;
  enviadoVendedor: boolean = false;

  filtrandoProduto: boolean = false;
  filtrandoCliente: boolean = false;
  filtrandoVendedor: boolean = false;

  filtroProdutos: any[] = [
    { texto: 'Código', valor: 'codigo' },
    { texto: 'Descrição', valor: 'descricao' },
    { texto: 'Marca', valor: 'marca' },
    { texto: 'Subgrupo 1', valor: 'subgrupo1' },
    { texto: 'Subgrupo 2', valor: 'subgrupo2' },
    { texto: 'Subgrupo 3', valor: 'subgrupo3' },
    { texto: 'Subgrupo 4', valor: 'subgrupo4' },
    { texto: 'Subgrupo 5', valor: 'subgrupo5' }
  ];

  filtroClientes: any[] = [
    { texto: 'Código', valor: 'codigo' },
    { texto: 'CNPJ/CPF', valor: 'cnpj_cpf' },
    { texto: 'Nome Fantasia', valor: 'nome_fantasia' },
    { texto: 'Razão Social', valor: 'razao_social' },
    { texto: 'Responsável', valor: 'responsavel' },
    { texto: 'Segmento', valor: 'segment' },
    { texto: 'Ramo de Atividade', valor: 'ramo_atividade' },
    { texto: 'Grupo Região', valor: 'grupo_regiao' },
    { texto: 'Subsegmento', valor: 'subsegmento' },
    { texto: 'Subsegmento 2', valor: 'subsegmento2' },
    { texto: 'Cidade', valor: 'cidade' },
    { texto: 'Classificação', valor: 'classificacao' }
  ];

  filtroVendedores: any[] = [
    { texto: 'Código', valor: 'codigo' },
    { texto: 'Nome', valor: 'nome' },
    { texto: 'Empresa', valor: 'empresa' },
    { texto: 'Equipe', valor: 'equipe' }
  ];

  filtrosAtivosProdutos: FiltroAtivo[] = [];
  filtrosAtivosClientes: FiltroAtivo[] = [];
  filtrosAtivosVendedores: FiltroAtivo[] = [];

  /* Filtro orgânico de produtos */
  filtroOrganico = {
    termo: '',
    codigo: '',
    descricao: '',
    marca: '',
    subgrupo1: '',
    subgrupo2: '',
    subgrupo3: '',
    subgrupo4: '',
    subgrupo5: '',
    ativo: 'TODOS'
  };
  produtosExibidos: Produto[] = [];
  limiteSemFiltro = 200;
  private filtroTimer: any;

  /* Inline editing de itens da campanha */
  itemEmEdicao: { index: number; campo: string } | null = null;

  marcasDisponiveis: string[] = [];
  subgrupos1Disponiveis: string[] = [];
  subgrupos2Disponiveis: string[] = [];
  subgrupos3Disponiveis: string[] = [];
  subgrupos4Disponiveis: string[] = [];
  subgrupos5Disponiveis: string[] = [];

  opcoesPorCampoCliente: { [campo: string]: string[] } = {};
  empresasDisponiveis: string[] = [];
  equipesDisponiveis: string[] = [];

  produtos: Produto[] = [];
  produtosOriginal: Produto[] = [];
  clientes: Cliente[] = [];
  clientesOriginal: Cliente[] = [];
  vendedores: Vendedor[] = [];
  vendedoresOriginal: Vendedor[] = [];

  produtoSelecionado: Produto | null = null;
  produtoEmBranco: boolean = false;
  produtoInvalido: boolean = false;
  produtoLoteErro: boolean = false;

  produtoCampanha: ProdutoCampanha | null = null;
  produtoCampanhaAtivo: boolean = true;
  produtoCampanhaKitCombo: string = 'K';
  produtoCampanhaPrecoBonificacao: string = 'P';
  produtoCampanhaBonificacaoMultiplicavel: boolean = false;
  produtoCampanhaBonificacaoSelecionavel: boolean = false;

  produtoCampanhaItemSelecionadoIndex: number = -1;
  produtoCampanhaItemAtivo: boolean = true;
  produtoCampanhaItemBonificacao: boolean = false;

  produtosCampanhaItens: ProdutoCampanhaItens[] = [];
  produtosCampanhaSelecionadosEmMassa: Set<string> = new Set<string>();
  produtosSelecionadosBusca: Set<number> = new Set<number>();
  produtosSelecionadosDetalhes: Produto[] = [];
  produtosPorId: Map<number, Produto> = new Map<number, Produto>();

  clientesCampanha: ProdutoCampanhaCliente[] = [];
  clientesSelecionadosBusca: Set<number> = new Set<number>();
  clientesCampanhaSelecionados: Set<number> = new Set<number>();

  vendedoresCampanha: ProdutoCampanhaVendedor[] = [];
  vendedoresSelecionadosBusca: Set<number> = new Set<number>();
  vendedoresCampanhaSelecionados: Set<number> = new Set<number>();

  percentualProdutos: number | null = null;
  quantidadeMinimaProdutos: number = 0;
  tipoCalculo: string = 'margem';
  dataInicioProdutos: string = '';
  dataFimProdutos: string = '';
  importarProdutosAtivos: boolean = true;

  edicaoEmMassaItens: any = {
    is_active: null,
    qtdade: null,
    preco: null,
    bonificacao: null,
    tipo_calculo: null,
    tipo_percentual: null,
    dt_inicio: '',
    dt_fim: ''
  };

  campanhaImagem: string = '';
  campanhaImagemErro: boolean = false;
  campanhaImagemInvalida: boolean = false;

  importacaoArquivo: File | null = null;
  importacaoLinhasValidas: ImportacaoCampanhaLinha[] = [];
  importacaoLinhasInvalidas: ImportacaoCampanhaLinha[] = [];
  importacaoErroUpload: string = '';
  importacaoProcessando: boolean = false;

  produtosLotes: ProdutoLote[] = [];
  exibirLote: boolean = false;
  modalReferenciaSelecionarLote: NgbModalRef | null = null;

  guidclientenapis: string = localStorage.getItem('guidclientenapis') || '';
  obs_gerais: string = localStorage.getItem('obs_gerais') || '';

  @ViewChild('arquivoImagem') arquivoImagem!: ElementRef;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private configuracaoService: ConfiguracaoService,
    private clienteService: ClienteService,
    private produtoService: ProdutoService,
    private vendedorService: VendedorService
  ) {
  }

  ngOnInit() {
    this.formProdutoCampanha = this.formBuilder.group({
      nome: ['', Validators.required],
      qtde: ['', Validators.required],
      id_no_erp_do_cliente: ['']
    });

    this.formProdutoCampanhaItem = this.formBuilder.group({
      qtde: [{ value: '', disabled: true }, Validators.required],
      preco: [{ value: '', disabled: true }, Validators.required],
      dt_inicio: [{ value: '', disabled: true }],
      dt_fim: [{ value: '', disabled: true }],
      tipo_calculo: [{ value: '', disabled: true }],
      tipo_percentual: [{ value: '', disabled: true }]
    });

    this.formFiltroProduto = this.formBuilder.group({
      filtro: ['descricao'],
      valor: ['', Validators.required]
    });

    this.formFiltroCliente = this.formBuilder.group({
      filtro: ['codigo'],
      valor: ['', Validators.required]
    });

    this.formFiltroVendedor = this.formBuilder.group({
      filtro: ['codigo'],
      valor: ['', Validators.required]
    });

    this.carregarDados();
  }

  get fpc() {
    return this.formProdutoCampanha.controls;
  }

  get fpi() {
    return this.formProdutoCampanhaItem.controls;
  }

  get ffp() {
    return this.formFiltroProduto.controls;
  }

  get ffc() {
    return this.formFiltroCliente.controls;
  }

  get ffv() {
    return this.formFiltroVendedor.controls;
  }

  get regrasGrupoClientes(): PromoRegraGrupo[] {
    return this.regrasGrupo.filter(r => r.entidade === 'cliente');
  }

  get regrasGrupoProdutos(): PromoRegraGrupo[] {
    return this.regrasGrupo.filter(r => r.entidade === 'produto');
  }

  carregarDados() {
    this.carregando = true;

    forkJoin([
      this.configuracaoService.getByGuidClienteNapis(),
      this.vendedorService.getByGuidClienteNapis(),
      this.clienteService.getClienteFiltrosConfigurados()
    ]).subscribe(
      (resultado: any[]) => {
        this.configuracao = resultado[0];
        this.usaPromocao = this.obterUsaPromocao(this.configuracao);
        this.itemMaximoPermitido = this.usaPromocao ? 4 : 2;

        this.vendedoresOriginal = resultado[1] || [];
        this.vendedores = [];

        const configClientes = resultado[2] || { filtros: [], buscaGeral: {} };
        const filtrosFixos = [
          { texto: 'Código', valor: 'codigo' },
          { texto: 'CNPJ/CPF', valor: 'cnpj_cpf' },
          { texto: 'Nome Fantasia', valor: 'nome_fantasia' },
          { texto: 'Razão Social', valor: 'razao_social' },
          { texto: 'Responsável', valor: 'responsavel' },
        ];
        const filtrosDinamicos = (configClientes.filtros || [])
          .filter((f: any) => f.opcoes && f.opcoes.length > 0)
          .map((f: any) => ({ texto: f.label, valor: f.campo }));
        const filtrosExtras = [
          { texto: 'Cidade', valor: 'cidade' },
          { texto: 'Classificação', valor: 'classificacao' },
        ];
        this.filtroClientes = [...filtrosFixos, ...filtrosDinamicos, ...filtrosExtras];

        this.opcoesPorCampoCliente = {};
        (configClientes.filtros || []).forEach((f: any) => {
          this.opcoesPorCampoCliente[f.campo] = f.opcoes || [];
        });

        this.extrairOpcoesDisponiveisVendedores();

        this.verificarAdicionandoAlterando();
      },
      error => {
        console.log('Erro: ' + error);
        this.carregando = false;
      }
    );
  }

  private obterUsaPromocao(configuracao: Configuracao | null): boolean {
    // As seções de Clientes, Vendedores e Regras de Grupo devem aparecer para
    // TODOS os clientes, independente da configuração (usa_pontuacao /
    // tabelalistaoupromocao). Mantido o parâmetro para compatibilidade.
    return true;
  }

  private indexarProdutosPorId() {
    for (let i = 0; i < this.produtos.length; i++) {
      this.produtosPorId.set(this.produtos[i].id, this.produtos[i]);
    }
  }

  private extrairOpcoesDisponiveisVendedores() {
    this.empresasDisponiveis = this.extrairUnicos(this.vendedoresOriginal, 'nm_empresa');
    this.equipesDisponiveis = this.extrairUnicos(this.vendedoresOriginal, 'nome_equipe');
  }

  private extrairOpcoesDisponiveis() {
    this.marcasDisponiveis = this.extrairUnicos(this.produtosOriginal, 'grupo_estoque');
    this.subgrupos1Disponiveis = this.extrairUnicos(this.produtosOriginal, 'subgrupo_estoque');
    this.subgrupos2Disponiveis = this.extrairUnicos(this.produtosOriginal, 'subgrupo_estoque2');
    this.subgrupos3Disponiveis = this.extrairUnicos(this.produtosOriginal, 'subgrupo_estoque3');
    this.subgrupos4Disponiveis = this.extrairUnicos(this.produtosOriginal, 'subgrupo_estoque4');
    this.subgrupos5Disponiveis = this.extrairUnicos(this.produtosOriginal, 'subgrupo_estoque5');

    // Opções de segmentação de cliente vêm do endpoint GetClienteFiltrosConfigurados (opcoesPorCampoCliente)

    this.empresasDisponiveis = this.extrairUnicos(this.vendedoresOriginal, 'nm_empresa');
    this.equipesDisponiveis = this.extrairUnicos(this.vendedoresOriginal, 'nome_equipe');
  }

  private extrairUnicos(lista: any[], campo: string): string[] {
    const valores: string[] = [];
    const mapa: any = {};

    for (let i = 0; i < lista.length; i++) {
      const valor = lista[i][campo];

      if (valor != null && String(valor).trim() !== '') {
        const texto = String(valor).trim();

        if (!mapa[texto]) {
          mapa[texto] = true;
          valores.push(texto);
        }
      }
    }

    return valores.sort();
  }

  verificarAdicionandoAlterando() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    let id: string | null = null;
    this.route.params.subscribe(params => { id = params.id; });

    if (id != null && !isNaN(parseInt(id, 10)) && isFinite(parseInt(id, 10))) {
      this.prepararReceberDados(parseInt(id, 10)).then(() => {
        this.carregando = false;
        // Lista vazia por padrão — usuário precisa clicar Filtrar
        this.produtos = [];
        this.produtosExibidos = [];
      });
    } else {
      this.carregando = false;
      // Lista vazia por padrão
      this.produtos = [];
      this.produtosExibidos = [];
    }
  }

  prepararReceberDados(id_campanha: number): Promise<void> {
    return new Promise<void>((resolver) => {
      this.produtoService.getProdutoCampanhaById(id_campanha).subscribe(
        campanha => this.produtoCampanha = campanha,
        error => {
          console.log('Erro: ' + error);
          this.router.navigate(['/produtos']);
          resolver();
        },
        () => {
          if (this.produtoCampanha == null) {
            this.toastr.error('', 'Campanha inválida!');
            this.router.navigate(['/produtos']);
            resolver();
            return;
          }

          this.formProdutoCampanha.controls['nome'].setValue(this.produtoCampanha.nome);
          this.formProdutoCampanha.controls['qtde'].setValue(this.produtoCampanha.qtde_minima);
          this.formProdutoCampanha.controls['id_no_erp_do_cliente'].setValue(this.produtoCampanha.id_no_erp_do_cliente);

          this.produtoCampanhaAtivo = this.produtoCampanha.is_active;
          this.produtoCampanhaKitCombo = this.produtoCampanha.kit_combo;
          this.produtoCampanhaPrecoBonificacao = this.produtoCampanha.preco_bonificacao;
          this.produtoCampanhaBonificacaoMultiplicavel = this.produtoCampanha.bonificacao_multiplicavel;
          this.produtoCampanhaBonificacaoSelecionavel = this.produtoCampanha.bonificacao_selecionavel;

          if (this.produtoCampanha.imagem != null) {
            this.campanhaImagem = 'data:image/png;base64,' + this.produtoCampanha.imagem;
          }

          forkJoin([
            this.produtoService.getProdutoCampanhaItensByIdCampanha(this.produtoCampanha.id),
            this.usaPromocao ? this.produtoService.getProdutoCampanhaClienteByIdCampanha(this.produtoCampanha.id) : of([]),
            this.usaPromocao ? this.produtoService.getProdutoCampanhaVendedorByIdCampanha(this.produtoCampanha.id) : of([])
          ]).subscribe(
            (resultado: any[]) => {
              this.produtosCampanhaItens = resultado[0] || [];
              this.clientesCampanha = resultado[1] || [];
              this.vendedoresCampanha = resultado[2] || [];

              for (let i = 0; i < this.clientesCampanha.length; i++) {
                if (!this.clientesCampanha[i].name) {
                  const c = this.clientesOriginal.find(x => x.id === this.clientesCampanha[i].idcliente);
                  if (c) { this.clientesCampanha[i].name = c.name; }
                }
              }

              for (let i = 0; i < this.vendedoresCampanha.length; i++) {
                if (!this.vendedoresCampanha[i].fullname) {
                  const v = this.vendedoresOriginal.find(x => x.id === this.vendedoresCampanha[i].idseller);
                  if (v) { this.vendedoresCampanha[i].fullname = v.fullname; }
                }
              }

              for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
                this.normalizarItemCarregado(this.produtosCampanhaItens[i]);
              }

              if (this.produtosCampanhaItens.length > 0) {
                const primeiroItem = this.produtosCampanhaItens[0];
                if (primeiroItem.dt_inicio && !this.dataInicioProdutos) {
                  this.dataInicioProdutos = primeiroItem.dt_inicio;
                }
                if (primeiroItem.dt_fim && !this.dataFimProdutos) {
                  this.dataFimProdutos = primeiroItem.dt_fim;
                }
              }

              this.verificarExibirLote();
              resolver();
            },
            error => {
              console.log('Erro: ' + error);
              resolver();
            }
          );
        }
      );
    });
  }

  private normalizarItemCarregado(item: ProdutoCampanhaItens) {
    item.tipo_calculo = this.mapearTipoBancoParaUi(item.tipo);
    item.dt_inicio = this.normalizarDataParaInput(item.dt_inicio);
    item.dt_fim = this.normalizarDataParaInput(item.dt_fim);

    if (item.id_lote != null && item.preco_lote != null) {
      item.price = item.preco_lote;
    }

    if (item.tipo_percentual == null && item.tipo_calculo !== '' && item.price != null && item.preco != null && !item.bonificacao) {
      item.tipo_percentual = this.calcularPercentualPorPreco(item.price, item.tipo_calculo, item.preco) || 0;
    }
  }

  alterarItemSelecionado(item: number) {
    this.validarItens();

    if (item > this.itemMaximoPermitido) {
      return;
    }

    this.itemSelecionado = item;
    if (item === 5) {
      this.carregarRegrasGrupo();
    }
  }

  prosseguirItemSelecionado(item: number) {
    this.validarItens();

    if ((item + 1) > this.itemMaximoPermitido) {
      return;
    }

    this.itemSelecionado = item + 1;
  }

  retornarItemSelecionado(item: number) {
    this.itemSelecionado = item - 1;
  }

  validarItens() {
    this.itemMaximoPermitido = this.usaPromocao
      ? (this.produtoCampanha?.id ? 5 : 4)
      : 2;

    if (this.produtoCampanhaKitCombo === 'K') {
      this.formProdutoCampanha.controls['qtde'].setErrors(null);
    }

    if (this.formProdutoCampanha.invalid) {
      this.enviadoProdutoCampanha = true;
      this.toastr.error('', 'Informações inválidas!');
      this.itemSelecionado = 0;
      this.itemMaximoPermitido = 0;
    }
  }

  selecionarProdutoCampanhaAtivo(ativo: string) {
    this.produtoCampanhaAtivo = ativo === '1';
  }

  selecionarProdutoCampanhaKitCombo(kit_combo: string) {
    this.produtoCampanhaKitCombo = kit_combo;

    if (this.produtoCampanhaKitCombo === 'K') {
      this.formProdutoCampanha.controls['qtde'].setValue('');
      this.formProdutoCampanha.controls['qtde'].setErrors(null);
    }

    this.changeDetector.detectChanges();
  }

  selecionarProdutoCampanhaPrecoBonificacao(preco_bonificacao: string) {
    this.produtoCampanhaPrecoBonificacao = preco_bonificacao;

    if (this.produtoCampanhaPrecoBonificacao === 'P') {
      this.produtoCampanhaItemBonificacao = false;
      this.produtoCampanhaBonificacaoMultiplicavel = false;
      this.produtoCampanhaBonificacaoSelecionavel = false;
    }
  }

  selecionarProdutoCampanhaBonificacaoMultiplicavel(bonificacao_multiplicavel: string) {
    this.produtoCampanhaBonificacaoMultiplicavel = bonificacao_multiplicavel === '1';
  }

  selecionarProdutoCampanhaBonificacaoSelecionavel(bonificacao_selecionavel: string) {
    this.produtoCampanhaBonificacaoSelecionavel = bonificacao_selecionavel === '1';

    if (!this.produtoCampanhaBonificacaoSelecionavel) {
      for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
        this.produtosCampanhaItens[i].bonificacao = false;
      }
    }
  }

  selecionarProdutoCampanhaItemAtivo(ativo: string) {
    this.produtoCampanhaItemAtivo = ativo === '1';
  }

  selecionarProdutoCampanhaItemBonificacao(bonificacao: string) {
    this.produtoCampanhaItemBonificacao = bonificacao === '1';

    if (this.produtoCampanhaItemBonificacao) {
      this.formProdutoCampanhaItem.controls['preco'].setValue(0);
      this.formProdutoCampanhaItem.controls['preco'].setErrors(null);
    }
  }

  alterarFiltroProdutoSelecionado() {
    this.formFiltroProduto.controls['valor'].setValue('');
  }

  adicionarFiltroProduto() {
    this.enviadoProduto = true;

    if (this.formFiltroProduto.invalid) {
      return;
    }

    this.adicionarFiltro(this.filtrosAtivosProdutos, this.formFiltroProduto.controls['filtro'].value, this.formFiltroProduto.controls['valor'].value);
    this.formFiltroProduto.controls['valor'].setValue('');
    this.enviadoProduto = false;
    // Não auto-filtra: usuário clica "Filtrar" explicitamente
  }

  removerFiltroProduto(index: number) {
    this.filtrosAtivosProdutos.splice(index, 1);
    this.filtrosAtivosProdutos = [...this.filtrosAtivosProdutos];
    // Não auto-filtra ao remover chip
  }

  limparTodosFiltrosProdutos() {
    this.filtrosAtivosProdutos = [];
    this.produtos = [];
    this.produtosExibidos = [];
    this.filtrandoProduto = false;
  }

  filtrarProduto() {
    this.filtrandoProduto = true;
    this.produtoService.searchPaged(this.filtrosAtivosProdutos, 0, 500).subscribe(resultado => {
      this.produtosOriginal = resultado.items;
      this.produtos = resultado.items;
      this.produtosExibidos = resultado.items;
      this.indexarProdutosPorId();
      this.filtrandoProduto = this.filtrosAtivosProdutos.length > 0;
    });
  }

  obterTextoFiltroProduto(tipo: string): string {
    return this.obterTextoFiltro(this.filtroProdutos, tipo);
  }

  private verificarProdutoFiltros(produto: Produto): boolean {
    for (let i = 0; i < this.filtrosAtivosProdutos.length; i++) {
      const filtro = this.filtrosAtivosProdutos[i];
      const valor = filtro.valor.toLowerCase();

      if (filtro.tipo === 'codigo' && !this.textoContem(produto.codigo, valor)) { return false; }
      if (filtro.tipo === 'descricao' && !this.textoContem(produto.name, valor)) { return false; }
      if (filtro.tipo === 'marca' && !this.textoContem(produto.grupo_estoque, valor)) { return false; }
      if (filtro.tipo === 'subgrupo1' && !this.textoContem(produto.subgrupo_estoque, valor)) { return false; }
      if (filtro.tipo === 'subgrupo2' && !this.textoContem(produto.subgrupo_estoque2, valor)) { return false; }
      if (filtro.tipo === 'subgrupo3' && !this.textoContem(produto.subgrupo_estoque3, valor)) { return false; }
      if (filtro.tipo === 'subgrupo4' && !this.textoContem(produto.subgrupo_estoque4, valor)) { return false; }
      if (filtro.tipo === 'subgrupo5' && !this.textoContem(produto.subgrupo_estoque5, valor)) { return false; }
    }

    return true;
  }

  selecionarProdutoBusca(id_produto: number) {
    if (this.produtosSelecionadosBusca.has(id_produto)) {
      this.produtosSelecionadosBusca.delete(id_produto);
    } else {
      this.produtosSelecionadosBusca.add(id_produto);
    }
  }

  selecionarTodosProdutosBusca() {
    if (this.produtos.length > 0 && this.produtosSelecionadosBusca.size === this.produtos.length) {
      this.produtosSelecionadosBusca.clear();
      return;
    }

    this.produtosSelecionadosBusca.clear();

    for (let i = 0; i < this.produtos.length; i++) {
      this.produtosSelecionadosBusca.add(this.produtos[i].id);
    }
  }

  estaProdutoSelecionadoBusca(id_produto: number): boolean {
    return this.produtosSelecionadosBusca.has(id_produto);
  }

  estaTodosProdutosBuscaSelecionados(): boolean {
    return this.produtos.length > 0 && this.produtosSelecionadosBusca.size === this.produtos.length;
  }

  abrirModalProdutosSelecionados(content: any) {
    this.produtosSelecionadosDetalhes = [];

    this.produtosSelecionadosBusca.forEach((id) => {
      const produto = this.produtosPorId.get(id);
      if (produto != null) {
        this.produtosSelecionadosDetalhes.push(produto);
      }
    });

    this.modalService.open(content, {
      ariaLabelledBy: 'titulo-produtos-adicionados-em-massa',
      size: 'lg',
      backdrop: 'static'
    });
  }

  selecionarProdutoFiltrado(id_produto: number) {
    const produtoSelecionado = this.produtosPorId.get(id_produto) || this.produtos.find(produto => produto.id === id_produto);

    if (produtoSelecionado == null) {
      return;
    }

    this.produtoSelecionado = JSON.parse(JSON.stringify(produtoSelecionado));
    if (this.produtoSelecionado != null) {
      this.produtoSelecionado.valor = this.produtoSelecionado.qtde_lote > 0 ? 0 : this.produtoSelecionado.price;
    }

    this.produtoCampanhaItemSelecionadoIndex = -1;
    this.produtoCampanhaItemAtivo = true;
    this.produtoCampanhaItemBonificacao = false;

    this.formProdutoCampanhaItem.reset();
    this.formProdutoCampanhaItem.controls['qtde'].enable();
    this.formProdutoCampanhaItem.controls['preco'].enable();
    this.formProdutoCampanhaItem.controls['dt_inicio'].enable();
    this.formProdutoCampanhaItem.controls['dt_fim'].enable();
    this.formProdutoCampanhaItem.controls['tipo_calculo'].enable();
    this.formProdutoCampanhaItem.controls['tipo_percentual'].enable();

    this.formProdutoCampanhaItem.controls['tipo_calculo'].setValue(this.tipoCalculo);
    this.formProdutoCampanhaItem.controls['dt_inicio'].setValue(this.dataInicioProdutos || '');
    this.formProdutoCampanhaItem.controls['dt_fim'].setValue(this.dataFimProdutos || '');

    this.produtoEmBranco = false;
    this.produtoInvalido = false;
    this.produtoLoteErro = false;
  }

  importarProdutosSelecionados() {
    if (this.produtosSelecionadosBusca.size === 0) {
      this.toastr.error('', 'Nenhum produto selecionado!');
      return;
    }

    if (this.tipoCalculo !== '' && (this.percentualProdutos == null || this.percentualProdutos === 0)) {
      this.toastr.error('', 'Informe o percentual para importação em massa.');
      return;
    }

    if (this.validarPeriodo(this.dataInicioProdutos, this.dataFimProdutos)) {
      this.toastr.error('', 'A data de início não pode ser maior que a data final.');
      return;
    }

    let adicionados = 0;
    let ignorados = 0;

    this.produtosSelecionadosBusca.forEach((id_produto) => {
      const produto = this.produtosPorId.get(id_produto) || this.produtos.find(p => p.id === id_produto);

      if (produto == null) {
        ignorados++;
        return;
      }

      const item = this.criarItemCampanha(produto, {
        qtdade: this.quantidadeMinimaProdutos,
        tipo_calculo: this.tipoCalculo,
        tipo_percentual: this.tipoCalculo === '' ? 0 : this.percentualProdutos,
        dt_inicio: this.dataInicioProdutos,
        dt_fim: this.dataFimProdutos,
        is_active: this.importarProdutosAtivos,
        bonificacao: false
      });

      if (this.existeItemDuplicado(item)) {
        ignorados++;
        return;
      }

      this.produtosCampanhaItens.push(item);
      adicionados++;
    });

    this.organizarProdutoCampanhaItens();
    this.verificarExibirLote();
    this.produtosSelecionadosBusca.clear();

    if (adicionados > 0) {
      this.toastr.success('', adicionados + ' produto(s) importado(s) com sucesso!' + (ignorados > 0 ? ' ' + ignorados + ' ignorado(s) por duplicidade.' : ''));
    } else {
      this.toastr.warning('', 'Nenhum produto foi importado.');
    }
  }

  private criarItemCampanha(produto: Produto, dados: any): ProdutoCampanhaItens {
    const item = new ProdutoCampanhaItens();
    const precoBase = produto.qtde_lote > 0 && produto.id_lote != null && produto.preco_lote != null
      ? produto.preco_lote
      : (produto.price != null && produto.price > 0 ? produto.price : produto.custo);

    item.id_campanha = this.produtoCampanha != null ? this.produtoCampanha.id : 0;
    item.product_id = produto.id;
    item.qtdade = dados.qtdade == null || dados.qtdade === '' ? 0 : Number(dados.qtdade);
    item.bonificacao = !!dados.bonificacao;
    item.is_active = dados.is_active !== false;
    item.id_lote = produto.id_lote;
    item.name = produto.name;
    item.codigo = produto.codigo;
    item.price = precoBase;
    item.nome_lote = produto.nome_lote;
    item.cod_lote = produto.cod_lote;
    item.estoque_lote = produto.estoque_lote;
    item.validade_lote = produto.validade_lote;
    item.preco_lote = produto.preco_lote;
    item.dt_inicio = this.normalizarDataParaInput(dados.dt_inicio);
    item.dt_fim = this.normalizarDataParaInput(dados.dt_fim);
    item.tipo_calculo = dados.tipo_calculo || '';
    item.tipo_percentual = dados.tipo_percentual == null || dados.tipo_percentual === '' ? 0 : Number(dados.tipo_percentual);

    if (dados.preco != null && dados.preco !== '') {
      item.preco = Number(dados.preco);
    } else if (item.tipo_calculo !== '' && item.tipo_percentual != null) {
      item.preco = this.calcularPrecoPorPercentual(precoBase, item.tipo_calculo, item.tipo_percentual) || 0;
    } else {
      item.preco = item.bonificacao ? 0 : precoBase;
    }

    if (!item.bonificacao && item.tipo_percentual == null && item.tipo_calculo !== '' && item.preco != null) {
      item.tipo_percentual = this.calcularPercentualPorPreco(precoBase, item.tipo_calculo, item.preco) || 0;
    }

    return item;
  }

  salvarProdutoCampanhaItem() {
    this.enviadoProdutoCampanhaItem = true;
    this.produtoEmBranco = false;
    this.produtoInvalido = false;
    this.produtoLoteErro = false;

    if (this.produtoSelecionado == null) {
      this.produtoEmBranco = true;
      this.toastr.error('', 'Produto em branco!');
      return;
    }

    if (this.produtoSelecionado.qtde_lote > 0 && this.produtoSelecionado.id_lote == null) {
      this.produtoLoteErro = true;
      this.toastr.error('', 'Selecione um lote para o produto.');
      return;
    }

    const item = this.criarItemCampanha(this.produtoSelecionado, {
      qtdade: this.formProdutoCampanhaItem.controls['qtde'].value,
      preco: this.formProdutoCampanhaItem.controls['preco'].value,
      tipo_calculo: this.formProdutoCampanhaItem.controls['tipo_calculo'].value,
      tipo_percentual: this.formProdutoCampanhaItem.controls['tipo_percentual'].value,
      dt_inicio: this.formProdutoCampanhaItem.controls['dt_inicio'].value,
      dt_fim: this.formProdutoCampanhaItem.controls['dt_fim'].value,
      is_active: this.produtoCampanhaItemAtivo,
      bonificacao: this.produtoCampanhaItemBonificacao
    });

    const erroValidacao = this.validarItemCampanha(item);
    if (erroValidacao != null) {
      this.toastr.error('', erroValidacao);
      return;
    }

    const indiceDuplicado = this.localizarIndiceDuplicado(item);
    if (indiceDuplicado !== -1 && indiceDuplicado !== this.produtoCampanhaItemSelecionadoIndex) {
      this.produtoInvalido = true;
      this.toastr.error('', 'Produto já adicionado à campanha.');
      return;
    }

    if (this.produtoCampanhaItemSelecionadoIndex !== -1) {
      item.id = this.produtosCampanhaItens[this.produtoCampanhaItemSelecionadoIndex].id;
      this.produtosCampanhaItens[this.produtoCampanhaItemSelecionadoIndex] = item;
      this.toastr.success('', 'Produto da campanha alterado com sucesso!');
    } else {
      this.produtosCampanhaItens.push(item);
      this.toastr.success('', 'Produto adicionado à campanha com sucesso!');
    }

    this.organizarProdutoCampanhaItens();
    this.reiniciarProdutoCampanhaItem();
    this.verificarExibirLote();
  }

  selecionarProdutoCampanhaItem(index: number) {
    const item = this.produtosCampanhaItens[index];
    const produtoBase = this.produtosPorId.get(item.product_id) || this.produtosOriginal.find(produto => produto.id === item.product_id || produto.codigo === item.codigo);

    this.produtoCampanhaItemSelecionadoIndex = index;
    this.produtoCampanhaItemAtivo = item.is_active;
    this.produtoCampanhaItemBonificacao = item.bonificacao;

    if (produtoBase != null) {
      this.produtoSelecionado = JSON.parse(JSON.stringify(produtoBase));
    } else {
      this.produtoSelecionado = new Produto();
      this.produtoSelecionado.id = item.product_id;
      this.produtoSelecionado.codigo = item.codigo;
      this.produtoSelecionado.name = item.name;
      this.produtoSelecionado.price = item.price;
      this.produtoSelecionado.qtde_lote = item.id_lote != null ? 1 : 0;
    }

    if (this.produtoSelecionado != null) {
      this.produtoSelecionado.valor = item.price;
      this.produtoSelecionado.id_lote = item.id_lote;
      this.produtoSelecionado.nome_lote = item.nome_lote;
      this.produtoSelecionado.cod_lote = item.cod_lote;
      this.produtoSelecionado.estoque_lote = item.estoque_lote;
      this.produtoSelecionado.validade_lote = item.validade_lote;
      this.produtoSelecionado.preco_lote = item.preco_lote;
    }

    this.formProdutoCampanhaItem.controls['qtde'].enable();
    this.formProdutoCampanhaItem.controls['preco'].enable();
    this.formProdutoCampanhaItem.controls['dt_inicio'].enable();
    this.formProdutoCampanhaItem.controls['dt_fim'].enable();
    this.formProdutoCampanhaItem.controls['tipo_calculo'].enable();
    this.formProdutoCampanhaItem.controls['tipo_percentual'].enable();

    this.formProdutoCampanhaItem.controls['qtde'].setValue(item.qtdade);
    this.formProdutoCampanhaItem.controls['preco'].setValue(item.preco);
    this.formProdutoCampanhaItem.controls['dt_inicio'].setValue(this.normalizarDataParaInput(item.dt_inicio));
    this.formProdutoCampanhaItem.controls['dt_fim'].setValue(this.normalizarDataParaInput(item.dt_fim));
    this.formProdutoCampanhaItem.controls['tipo_calculo'].setValue(item.tipo_calculo || this.mapearTipoBancoParaUi(item.tipo));
    this.formProdutoCampanhaItem.controls['tipo_percentual'].setValue(item.tipo_percentual);
  }

  reiniciarProdutoCampanhaItem() {
    this.formProdutoCampanhaItem.reset();
    this.formProdutoCampanhaItem.controls['qtde'].disable();
    this.formProdutoCampanhaItem.controls['preco'].disable();
    this.formProdutoCampanhaItem.controls['dt_inicio'].disable();
    this.formProdutoCampanhaItem.controls['dt_fim'].disable();
    this.formProdutoCampanhaItem.controls['tipo_calculo'].disable();
    this.formProdutoCampanhaItem.controls['tipo_percentual'].disable();

    this.enviadoProdutoCampanhaItem = false;
    this.produtoEmBranco = false;
    this.produtoInvalido = false;
    this.produtoLoteErro = false;

    this.produtoCampanhaItemSelecionadoIndex = -1;
    this.produtoCampanhaItemAtivo = true;
    this.produtoCampanhaItemBonificacao = false;
    this.produtoSelecionado = null;
  }

  removerProdutoCampanhaItem(index: number) {
    this.produtosCampanhaItens.splice(index, 1);
    this.produtosCampanhaItens = [...this.produtosCampanhaItens];
    this.verificarExibirLote();
    this.toastr.success('', 'Item removido da campanha.');
  }

  organizarProdutoCampanhaItens() {
    this.produtosCampanhaItens = this.produtosCampanhaItens.sort((a, b) => {
      const nomeA = a.name == null ? '' : a.name.toLowerCase();
      const nomeB = b.name == null ? '' : b.name.toLowerCase();
      if (nomeA < nomeB) { return -1; }
      if (nomeA > nomeB) { return 1; }
      return 0;
    });
  }

  verificarExibirLote() {
    this.exibirLote = false;

    for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
      if (this.produtosCampanhaItens[i].id_lote != null) {
        this.exibirLote = true;
        return;
      }
    }
  }

  selecionarProdutoCampanhaTabela(index: number) {
    const chave = this.obterChaveItemCampanha(this.produtosCampanhaItens[index], index);

    if (this.produtosCampanhaSelecionadosEmMassa.has(chave)) {
      this.produtosCampanhaSelecionadosEmMassa.delete(chave);
    } else {
      this.produtosCampanhaSelecionadosEmMassa.add(chave);
    }
  }

  selecionarTodosProdutosCampanhaTabela() {
    if (this.produtosCampanhaItens.length > 0 && this.produtosCampanhaSelecionadosEmMassa.size === this.produtosCampanhaItens.length) {
      this.produtosCampanhaSelecionadosEmMassa.clear();
      return;
    }

    this.produtosCampanhaSelecionadosEmMassa.clear();

    for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
      this.produtosCampanhaSelecionadosEmMassa.add(this.obterChaveItemCampanha(this.produtosCampanhaItens[i], i));
    }
  }

  estaProdutoCampanhaSelecionado(index: number): boolean {
    return this.produtosCampanhaSelecionadosEmMassa.has(this.obterChaveItemCampanha(this.produtosCampanhaItens[index], index));
  }

  estaTodosProdutosCampanhaSelecionados(): boolean {
    return this.produtosCampanhaItens.length > 0 && this.produtosCampanhaSelecionadosEmMassa.size === this.produtosCampanhaItens.length;
  }

  aplicarEdicaoEmMassaItens() {
    if (this.produtosCampanhaSelecionadosEmMassa.size === 0) {
      this.toastr.info('', 'Selecione pelo menos um item da campanha.');
      return;
    }

    if (this.validarPeriodo(this.edicaoEmMassaItens.dt_inicio, this.edicaoEmMassaItens.dt_fim)) {
      this.toastr.error('', 'A data de início não pode ser maior que a data final.');
      return;
    }

    let alterados = 0;

    for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
      const item = this.produtosCampanhaItens[i];
      const chave = this.obterChaveItemCampanha(item, i);

      if (!this.produtosCampanhaSelecionadosEmMassa.has(chave)) {
        continue;
      }

      if (this.edicaoEmMassaItens.is_active != null) {
        item.is_active = this.edicaoEmMassaItens.is_active;
      }

      if (this.edicaoEmMassaItens.qtdade != null && this.edicaoEmMassaItens.qtdade !== '') {
        item.qtdade = Number(this.edicaoEmMassaItens.qtdade);
      }

      if (this.edicaoEmMassaItens.bonificacao != null) {
        item.bonificacao = this.edicaoEmMassaItens.bonificacao;
      }

      if (this.edicaoEmMassaItens.tipo_calculo != null && this.edicaoEmMassaItens.tipo_calculo !== '') {
        item.tipo_calculo = this.edicaoEmMassaItens.tipo_calculo;
      }

      if (this.edicaoEmMassaItens.tipo_percentual != null && this.edicaoEmMassaItens.tipo_percentual !== '') {
        item.tipo_percentual = Number(this.edicaoEmMassaItens.tipo_percentual);
      }

      if (this.edicaoEmMassaItens.preco != null && this.edicaoEmMassaItens.preco !== '') {
        item.preco = Number(this.edicaoEmMassaItens.preco);
      } else if (item.tipo_calculo !== '' && item.tipo_percentual != null && !item.bonificacao) {
        item.preco = this.calcularPrecoPorPercentual(item.price, item.tipo_calculo, item.tipo_percentual) || 0;
      }

      if (this.edicaoEmMassaItens.dt_inicio != null && this.edicaoEmMassaItens.dt_inicio !== '') {
        item.dt_inicio = this.edicaoEmMassaItens.dt_inicio;
      }

      if (this.edicaoEmMassaItens.dt_fim != null && this.edicaoEmMassaItens.dt_fim !== '') {
        item.dt_fim = this.edicaoEmMassaItens.dt_fim;
      }

      if (item.tipo_calculo !== '' && item.tipo_percentual == null && item.preco != null && !item.bonificacao) {
        item.tipo_percentual = this.calcularPercentualPorPreco(item.price, item.tipo_calculo, item.preco) || 0;
      }

      const erro = this.validarItemCampanha(item);
      if (erro != null) {
        this.toastr.error('', item.codigo + ': ' + erro);
        return;
      }

      alterados++;
    }

    this.toastr.success('', alterados + ' item(ns) atualizado(s) em massa.');
    this.limparEdicaoEmMassaItens();
  }

  limparEdicaoEmMassaItens() {
    this.edicaoEmMassaItens = {
      is_active: null,
      qtdade: null,
      preco: null,
      bonificacao: null,
      tipo_calculo: null,
      tipo_percentual: null,
      dt_inicio: '',
      dt_fim: ''
    };
  }

  /* ─── Filtro Orgânico de Produtos ────────────────────────── */

  onFiltroChange(): void {
    clearTimeout(this.filtroTimer);
    this.filtroTimer = setTimeout(() => this.aplicarFiltroProdutosOrganico(), 250);
  }

  aplicarFiltroProdutosOrganico(): void {
    const f = this.filtroOrganico;
    const temFiltro =
      f.termo.trim() !== '' ||
      f.codigo.trim() !== '' ||
      f.descricao.trim() !== '' ||
      f.marca !== '' ||
      f.subgrupo1 !== '' ||
      f.subgrupo2 !== '' ||
      f.subgrupo3 !== '' ||
      f.subgrupo4 !== '' ||
      f.subgrupo5 !== '' ||
      f.ativo !== 'TODOS';

    let lista = this.produtosOriginal.filter(produto => {
      if (f.termo.trim() !== '' &&
        !this.textoContem(produto.name, f.termo.toLowerCase()) &&
        !this.textoContem(produto.codigo, f.termo.toLowerCase())) { return false; }
      if (f.codigo.trim() !== '' && !this.textoContem(produto.codigo, f.codigo.toLowerCase())) { return false; }
      if (f.descricao.trim() !== '' && !this.textoContem(produto.name, f.descricao.toLowerCase())) { return false; }
      if (f.marca !== '' && !this.textoContem(produto.grupo_estoque, f.marca.toLowerCase())) { return false; }
      if (f.subgrupo1 !== '' && !this.textoContem(produto.subgrupo_estoque, f.subgrupo1.toLowerCase())) { return false; }
      if (f.subgrupo2 !== '' && !this.textoContem(produto.subgrupo_estoque2, f.subgrupo2.toLowerCase())) { return false; }
      if (f.subgrupo3 !== '' && !this.textoContem(produto.subgrupo_estoque3, f.subgrupo3.toLowerCase())) { return false; }
      if (f.subgrupo4 !== '' && !this.textoContem(produto.subgrupo_estoque4, f.subgrupo4.toLowerCase())) { return false; }
      if (f.subgrupo5 !== '' && !this.textoContem(produto.subgrupo_estoque5, f.subgrupo5.toLowerCase())) { return false; }
      return true;
    });

    if (!temFiltro) {
      lista = lista.slice(0, this.limiteSemFiltro);
    }

    this.filtrandoProduto = temFiltro;
    this.produtos = lista;
    this.produtosExibidos = lista;
  }

  limparFiltroOrganico(): void {
    this.filtroOrganico = { termo: '', codigo: '', descricao: '', marca: '', subgrupo1: '', subgrupo2: '', subgrupo3: '', subgrupo4: '', subgrupo5: '', ativo: 'TODOS' };
    this.aplicarFiltroProdutosOrganico();
  }

  /* ─── Inline Editing dos Itens da Campanha ───────────────── */

  iniciarEdicaoItem(index: number, campo: string): void {
    this.itemEmEdicao = { index, campo };
    setTimeout(() => {
      const el = document.querySelector<HTMLElement>('.item-edit-focus');
      if (el) { el.focus(); }
    }, 30);
  }

  finalizarEdicaoItem(index: number, campo: string): void {
    if (this.itemEmEdicao != null && this.itemEmEdicao.index === index && this.itemEmEdicao.campo === campo) {
      this.itemEmEdicao = null;
      const item = this.produtosCampanhaItens[index];
      if (campo === 'tipo_percentual') {
        this.recalcularPrecoItem(item);
      } else if (campo === 'preco') {
        this.recalcularPercentualItem(item);
      } else if (campo === 'tipo_calculo') {
        this.recalcularPrecoItem(item);
      }
    }
  }

  cancelarEdicaoItem(): void {
    this.itemEmEdicao = null;
  }

  estaEditandoItem(index: number, campo: string): boolean {
    return this.itemEmEdicao != null &&
      this.itemEmEdicao.index === index &&
      this.itemEmEdicao.campo === campo;
  }

  /* ─── Helpers de Seleção ─────────────────────────────────── */

  get produtosSelecionadosBuscaArray(): number[] {
    return Array.from(this.produtosSelecionadosBusca);
  }

  /* ─── Modal Item Campanha ─────────────────────────────────────────────── */

  modalReferenciaItemCampanha: NgbModalRef | null = null;

  abrirModalItemCampanha(id_produto: number, content: any) {
    this.selecionarProdutoFiltrado(id_produto);
    this.modalReferenciaItemCampanha = this.modalService.open(content, {
      ariaLabelledBy: 'titulo-item-campanha',
      size: 'lg',
      backdrop: 'static'
    });
  }

  abrirModalEditarItemCampanha(index: number, content: any) {
    this.selecionarProdutoCampanhaItem(index);
    this.modalReferenciaItemCampanha = this.modalService.open(content, {
      ariaLabelledBy: 'titulo-item-campanha',
      size: 'lg',
      backdrop: 'static'
    });
  }

  salvarItemModal() {
    this.salvarProdutoCampanhaItem();
    // reiniciarProdutoCampanhaItem() seta produtoSelecionado = null em caso de sucesso
    if (this.produtoSelecionado === null && !this.produtoEmBranco) {
      if (this.modalReferenciaItemCampanha) {
        this.modalReferenciaItemCampanha.close();
        this.modalReferenciaItemCampanha = null;
      }
    }
  }

  fecharModalItemCampanha() {
    this.reiniciarProdutoCampanhaItem();
    if (this.modalReferenciaItemCampanha) {
      this.modalReferenciaItemCampanha.close();
      this.modalReferenciaItemCampanha = null;
    }
  }

  onModalPercentualChange() {
    const tipo = this.formProdutoCampanhaItem.controls['tipo_calculo'].value;
    const percentual = this.formProdutoCampanhaItem.controls['tipo_percentual'].value;
    const precoBase = this.produtoSelecionado ? this.produtoSelecionado.valor : null;

    if (precoBase != null && tipo && percentual != null && percentual !== '') {
      const preco = this.calcularPrecoPorPercentual(precoBase, tipo, Number(percentual));
      if (preco != null) {
        this.formProdutoCampanhaItem.controls['preco'].setValue(preco, { emitEvent: false });
      }
    }
  }

  onModalPrecoChange() {
    const tipo = this.formProdutoCampanhaItem.controls['tipo_calculo'].value;
    const preco = this.formProdutoCampanhaItem.controls['preco'].value;
    const precoBase = this.produtoSelecionado ? this.produtoSelecionado.valor : null;

    if (precoBase != null && precoBase > 0 && tipo && preco != null && preco !== '') {
      const percentual = this.calcularPercentualPorPreco(precoBase, tipo, Number(preco));
      if (percentual != null) {
        this.formProdutoCampanhaItem.controls['tipo_percentual'].setValue(percentual, { emitEvent: false });
      }
    }
  }

  onModalTipoCalculoChange() {
    this.onModalPercentualChange();
  }

  /* ─── Filtro com Chips — Select dinâmico por campo ───────────────────── */

  get opcoesValorFiltro(): string[] {
    const campo = this.formFiltroProduto && this.formFiltroProduto.controls['filtro']
      ? this.formFiltroProduto.controls['filtro'].value
      : null;
    switch (campo) {
      case 'marca': return this.marcasDisponiveis;
      case 'subgrupo1': return this.subgrupos1Disponiveis;
      case 'subgrupo2': return this.subgrupos2Disponiveis;
      case 'subgrupo3': return this.subgrupos3Disponiveis;
      case 'subgrupo4': return this.subgrupos4Disponiveis;
      case 'subgrupo5': return this.subgrupos5Disponiveis;
      default: return [];
    }
  }

  get filtroValorEhSelect(): boolean {
    return this.opcoesValorFiltro.length > 0;
  }

  get opcoesValorFiltroCliente(): string[] {
    const campo = this.formFiltroCliente && this.formFiltroCliente.controls['filtro']
      ? this.formFiltroCliente.controls['filtro'].value
      : null;
    if (!campo) return [];
    return this.opcoesPorCampoCliente[campo] || [];
  }

  get filtroValorClienteEhSelect(): boolean {
    return this.opcoesValorFiltroCliente.length > 0;
  }

  get opcoesValorFiltroVendedor(): string[] {
    const campo = this.formFiltroVendedor && this.formFiltroVendedor.controls['filtro']
      ? this.formFiltroVendedor.controls['filtro'].value
      : null;
    switch (campo) {
      case 'empresa': return this.empresasDisponiveis;
      case 'equipe': return this.equipesDisponiveis;
      default: return [];
    }
  }

  get filtroValorVendedorEhSelect(): boolean {
    return this.opcoesValorFiltroVendedor.length > 0;
  }

  /* ─── TrackBy functions (performance) ─────────────────────────────────── */

  trackByProdutoId(_index: number, produto: Produto): number {
    return produto.id;
  }

  trackByClienteId(_index: number, cliente: Cliente): number {
    return cliente.id;
  }

  trackByVendedorId(_index: number, vendedor: Vendedor): number {
    return vendedor.id;
  }

  removerItensSelecionadosEmMassa() {
    if (this.produtosCampanhaSelecionadosEmMassa.size === 0) {
      this.toastr.info('', 'Selecione pelo menos um item da campanha.');
      return;
    }

    const itensRestantes: ProdutoCampanhaItens[] = [];

    for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
      if (!this.produtosCampanhaSelecionadosEmMassa.has(this.obterChaveItemCampanha(this.produtosCampanhaItens[i], i))) {
        itensRestantes.push(this.produtosCampanhaItens[i]);
      }
    }

    const removidos = this.produtosCampanhaItens.length - itensRestantes.length;
    this.produtosCampanhaItens = itensRestantes;
    this.produtosCampanhaSelecionadosEmMassa.clear();
    this.verificarExibirLote();
    this.toastr.success('', removidos + ' item(ns) removido(s) da campanha.');
  }

  recalcularPrecoItem(item: ProdutoCampanhaItens) {
    if (item.bonificacao) {
      item.preco = 0;
      return;
    }

    if (item.tipo_calculo !== '' && item.tipo_percentual != null) {
      item.preco = this.calcularPrecoPorPercentual(item.price, item.tipo_calculo, item.tipo_percentual) || 0;
    }
  }

  recalcularPercentualItem(item: ProdutoCampanhaItens) {
    if (item.bonificacao) {
      item.tipo_percentual = 0;
      return;
    }

    if (item.tipo_calculo !== '' && item.preco != null) {
      item.tipo_percentual = this.calcularPercentualPorPreco(item.price, item.tipo_calculo, item.preco) || 0;
    }
  }

  onArquivoImportacaoSelecionado(event: any) {
    this.importacaoErroUpload = '';
    this.importacaoLinhasValidas = [];
    this.importacaoLinhasInvalidas = [];

    const file: File = event.target.files[0];
    if (!file) {
      return;
    }

    this.importacaoArquivo = file;
    this.importacaoProcessando = true;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

        if (rows.length < 2) {
          this.importacaoErroUpload = 'Planilha vazia ou sem dados.';
          this.importacaoProcessando = false;
          return;
        }

        this.processarLinhasImportacao(rows);
      } catch (err) {
        this.importacaoErroUpload = 'Erro ao ler o arquivo. Verifique se o arquivo Excel/CSV é válido.';
      }

      this.importacaoProcessando = false;
    };

    reader.readAsBinaryString(file);
  }

  private processarLinhasImportacao(rows: any[][]) {
    const headers: string[] = [];
    for (let h = 0; h < rows[0].length; h++) {
      headers.push(String(rows[0][h] || '').trim().toUpperCase());
    }

    let idxCodigo = headers.indexOf('CODIGO');
    if (idxCodigo === -1) {
      idxCodigo = headers.indexOf('CODPROD');
    }

    if (idxCodigo === -1) {
      this.importacaoErroUpload = 'Coluna obrigatória não encontrada. Use CODIGO ou CODPROD.';
      return;
    }

    const idxQtde = headers.indexOf('QTDE');
    const idxPreco = headers.indexOf('PRECO');
    const idxTipo = headers.indexOf('TIPO');
    const idxTipoPercentual = headers.indexOf('TIPO_PERCENTUAL');
    const idxAtivo = headers.indexOf('ATIVO');
    const idxBonificacao = headers.indexOf('BONIFICACAO');

    for (let i = 1; i < rows.length; i++) {
      const row = rows[i];
      const codigo = String(row[idxCodigo] || '').trim();

      if (codigo === '') {
        continue;
      }

      const produto = this.produtosOriginal.find(p => p.codigo != null && p.codigo.toLowerCase() === codigo.toLowerCase())
        || Array.from(this.produtosPorId.values()).find(p => p.codigo != null && p.codigo.toLowerCase() === codigo.toLowerCase());
      const linhaImportacao: ImportacaoCampanhaLinha = {
        linha: i + 1,
        codigo: codigo,
        nome: produto != null ? produto.name : '',
        qtdade: idxQtde === -1 ? 0 : (this.normalizarNumero(row[idxQtde]) || 0),
        preco: idxPreco === -1 ? null : this.normalizarNumero(row[idxPreco]),
        tipo_calculo: idxTipo === -1 ? '' : this.normalizarTipoUi(String(row[idxTipo] || '')),
        tipo_percentual: idxTipoPercentual === -1 ? null : this.normalizarNumero(row[idxTipoPercentual]),
        dt_inicio: this.dataInicioProdutos || '',
        dt_fim: this.dataFimProdutos || '',
        is_active: idxAtivo === -1 ? true : this.normalizarBoolean(row[idxAtivo]),
        bonificacao: idxBonificacao === -1 ? false : this.normalizarBoolean(row[idxBonificacao]),
        product_id: produto != null ? produto.id : 0,
        id_lote: null,
        price: produto != null ? (produto.price != null && produto.price > 0 ? produto.price : produto.custo) : 0
      };

      if (produto == null) {
        linhaImportacao.erro = 'Produto não encontrado.';
        this.importacaoLinhasInvalidas.push(linhaImportacao);
        continue;
      }

      if (linhaImportacao.preco == null && linhaImportacao.tipo_calculo !== '' && linhaImportacao.tipo_percentual != null) {
        linhaImportacao.preco = this.calcularPrecoPorPercentual(linhaImportacao.price, linhaImportacao.tipo_calculo, linhaImportacao.tipo_percentual);
      }

      const itemValidacao = new ProdutoCampanhaItens();
      itemValidacao.product_id = linhaImportacao.product_id;
      itemValidacao.codigo = linhaImportacao.codigo;
      itemValidacao.name = linhaImportacao.nome;
      itemValidacao.qtdade = linhaImportacao.qtdade;
      itemValidacao.preco = linhaImportacao.preco || 0;
      itemValidacao.price = linhaImportacao.price;
      itemValidacao.tipo_calculo = linhaImportacao.tipo_calculo;
      itemValidacao.tipo_percentual = linhaImportacao.tipo_percentual || 0;
      itemValidacao.dt_inicio = linhaImportacao.dt_inicio;
      itemValidacao.dt_fim = linhaImportacao.dt_fim;
      itemValidacao.is_active = linhaImportacao.is_active;
      itemValidacao.bonificacao = linhaImportacao.bonificacao;

      const erro = this.validarItemCampanha(itemValidacao);
      if (erro != null) {
        linhaImportacao.erro = erro;
        this.importacaoLinhasInvalidas.push(linhaImportacao);
        continue;
      }

      this.importacaoLinhasValidas.push(linhaImportacao);
    }
  }

  confirmarImportacaoArquivo() {
    if (this.importacaoLinhasValidas.length === 0) {
      this.toastr.info('', 'Nenhuma linha válida disponível para importação.');
      return;
    }

    let inseridos = 0;
    let atualizados = 0;

    for (let i = 0; i < this.importacaoLinhasValidas.length; i++) {
      const linha = this.importacaoLinhasValidas[i];
      const produto = this.produtosPorId.get(linha.product_id) || this.produtosOriginal.find(p => p.id === linha.product_id);

      if (produto == null) {
        continue;
      }

      const item = this.criarItemCampanha(produto, linha);
      const indiceExistente = this.localizarIndiceDuplicado(item);

      if (indiceExistente !== -1) {
        item.id = this.produtosCampanhaItens[indiceExistente].id;
        this.produtosCampanhaItens[indiceExistente] = item;
        atualizados++;
      } else {
        this.produtosCampanhaItens.push(item);
        inseridos++;
      }
    }

    this.organizarProdutoCampanhaItens();
    this.verificarExibirLote();

    this.toastr.success('', 'Importação concluída. Inseridos: ' + inseridos + '. Atualizados: ' + atualizados + '.');
  }

  baixarModeloImportacao() {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([
      ['CODIGO', 'QTDE', 'PRECO', 'TIPO', 'TIPO_PERCENTUAL', 'ATIVO', 'BONIFICACAO'],
      ['123', 1, 99.9, 'MARGEM', 10, 'SIM', 'NAO'],
      ['456', 2, '', 'DESCONTO', 5, 'SIM', 'NAO']
    ]);

    XLSX.utils.book_append_sheet(wb, ws, 'Campanhas');
    XLSX.writeFile(wb, 'modelo_importacao_campanhas.xlsx');
  }

  limparImportacaoArquivo() {
    this.importacaoArquivo = null;
    this.importacaoLinhasValidas = [];
    this.importacaoLinhasInvalidas = [];
    this.importacaoErroUpload = '';
  }

  alterarFiltroClienteSelecionado() {
    this.formFiltroCliente.controls['valor'].setValue('');
  }

  adicionarFiltroCliente() {
    this.enviadoCliente = true;

    if (this.formFiltroCliente.invalid) {
      return;
    }

    this.adicionarFiltro(this.filtrosAtivosClientes, this.formFiltroCliente.controls['filtro'].value, this.formFiltroCliente.controls['valor'].value);
    this.formFiltroCliente.controls['valor'].setValue('');
    this.enviadoCliente = false;
  }

  removerFiltroCliente(index: number) {
    this.filtrosAtivosClientes.splice(index, 1);
    this.filtrosAtivosClientes = [...this.filtrosAtivosClientes];
  }

  limparTodosFiltrosClientes() {
    this.filtrosAtivosClientes = [];
    this.clientes = [];
    this.filtrandoCliente = false;
  }

  filtrarCliente() {
    this.filtrandoCliente = true;
    this.clienteService.searchPaged(this.filtrosAtivosClientes, 0, 500).subscribe(resultado => {
      this.clientesOriginal = resultado.items;
      this.clientes = resultado.items;
      this.filtrandoCliente = this.filtrosAtivosClientes.length > 0;
    });
  }

  obterTextoFiltroCliente(tipo: string): string {
    return this.obterTextoFiltro(this.filtroClientes, tipo);
  }

  private verificarClienteFiltros(cliente: Cliente): boolean {
    for (let i = 0; i < this.filtrosAtivosClientes.length; i++) {
      const filtro = this.filtrosAtivosClientes[i];
      const valor = filtro.valor.toLowerCase();

      if (filtro.tipo === 'codigo' && !this.textoContem(cliente.codigo_no_erp_do_cliente, valor)) { return false; }
      if (filtro.tipo === 'cnpj_cpf' && !this.textoContem(cliente.client_document, valor)) { return false; }
      if (filtro.tipo === 'nome_fantasia' && !this.textoContem(cliente.fantasia, valor)) { return false; }
      if (filtro.tipo === 'razao_social' && !this.textoContem(cliente.razaosocial, valor)) { return false; }
      if (filtro.tipo === 'responsavel' && !this.textoContem(cliente.responsible_name, valor)) { return false; }
      if (filtro.tipo === 'segment' && !this.textoContem(cliente.segment, valor)) { return false; }
      if (filtro.tipo === 'ramo_atividade' && !this.textoContem(cliente.ramo_atividade, valor)) { return false; }
      if (filtro.tipo === 'grupo_regiao' && !this.textoContem(cliente.grupo_regiao, valor)) { return false; }
      if (filtro.tipo === 'subsegmento' && !this.textoContem(cliente.subsegmento, valor)) { return false; }
      if (filtro.tipo === 'subsegmento2' && !this.textoContem(cliente.subsegmento2, valor)) { return false; }
      if (filtro.tipo === 'cidade' && !this.textoContem(cliente.cidade, valor)) { return false; }
      if (filtro.tipo === 'classificacao' && !this.textoContem(cliente.classificacao, valor)) { return false; }
    }

    return true;
  }

  selecionarClienteBusca(id_cliente: number) {
    if (this.clientesSelecionadosBusca.has(id_cliente)) {
      this.clientesSelecionadosBusca.delete(id_cliente);
    } else {
      this.clientesSelecionadosBusca.add(id_cliente);
    }
  }

  selecionarTodosClientesBusca() {
    if (this.clientes.length > 0 && this.clientesSelecionadosBusca.size === this.clientes.length) {
      this.clientesSelecionadosBusca.clear();
      return;
    }

    this.clientesSelecionadosBusca.clear();
    for (let i = 0; i < this.clientes.length; i++) {
      this.clientesSelecionadosBusca.add(this.clientes[i].id);
    }
  }

  estaClienteSelecionadoBusca(id_cliente: number): boolean {
    return this.clientesSelecionadosBusca.has(id_cliente);
  }

  estaTodosClientesBuscaSelecionados(): boolean {
    return this.clientes.length > 0 && this.clientesSelecionadosBusca.size === this.clientes.length;
  }

  importarClientesSelecionados() {
    if (this.clientesSelecionadosBusca.size === 0) {
      this.toastr.error('', 'Nenhum cliente selecionado!');
      return;
    }

    let adicionados = 0;

    this.clientesSelecionadosBusca.forEach((id_cliente) => {
      const cliente = this.clientes.find(item => item.id === id_cliente);

      if (cliente == null || this.clienteJaVinculado(id_cliente)) {
        return;
      }

      const vinculo = new ProdutoCampanhaCliente();
      vinculo.id_product_campanha = this.produtoCampanha != null ? this.produtoCampanha.id : 0;
      vinculo.idcliente = cliente.id;
      vinculo.name = cliente.name;

      this.clientesCampanha.push(vinculo);
      adicionados++;
    });

    this.clientesCampanha = this.clientesCampanha.sort((a, b) => {
      const nomeA = a.name == null ? '' : a.name.toLowerCase();
      const nomeB = b.name == null ? '' : b.name.toLowerCase();
      if (nomeA < nomeB) { return -1; }
      if (nomeA > nomeB) { return 1; }
      return 0;
    });

    this.clientesSelecionadosBusca.clear();
    this.toastr.success('', adicionados + ' cliente(s) vinculado(s) localmente à campanha.');
  }

  removerClienteCampanha(index: number) {
    const vinculo = this.clientesCampanha[index];
    if (vinculo == null) {
      return;
    }

    if (vinculo.id != null && vinculo.id > 0) {
      this.produtoService.deleteProdutoCampanhaClienteById(vinculo.id).subscribe(
        removido => {
          if (removido) {
            this.clientesCampanha.splice(index, 1);
            this.clientesCampanha = [...this.clientesCampanha];
            this.clientesCampanhaSelecionados.delete(vinculo.idcliente);
            this.toastr.success('', 'Cliente desvinculado da campanha.');
          }
        }
      );
      return;
    }

    this.clientesCampanha.splice(index, 1);
    this.clientesCampanha = [...this.clientesCampanha];
    this.clientesCampanhaSelecionados.delete(vinculo.idcliente);
  }

  selecionarClienteCampanha(idcliente: number) {
    if (this.clientesCampanhaSelecionados.has(idcliente)) {
      this.clientesCampanhaSelecionados.delete(idcliente);
    } else {
      this.clientesCampanhaSelecionados.add(idcliente);
    }
  }

  estaClienteCampanhaSelecionado(idcliente: number): boolean {
    return this.clientesCampanhaSelecionados.has(idcliente);
  }

  estaTodosClientesCampanhaSelecionados(): boolean {
    return this.clientesCampanha.length > 0 && this.clientesCampanhaSelecionados.size === this.clientesCampanha.length;
  }

  selecionarTodosClientesCampanha() {
    if (this.estaTodosClientesCampanhaSelecionados()) {
      this.clientesCampanhaSelecionados.clear();
      return;
    }
    this.clientesCampanhaSelecionados.clear();
    for (let i = 0; i < this.clientesCampanha.length; i++) {
      this.clientesCampanhaSelecionados.add(this.clientesCampanha[i].idcliente);
    }
  }

  removerClientesCampanhaEmMassa() {
    if (this.clientesCampanhaSelecionados.size === 0) {
      this.toastr.info('', 'Selecione pelo menos um cliente.');
      return;
    }

    const selecionados = this.clientesCampanha.filter(c => this.clientesCampanhaSelecionados.has(c.idcliente));
    const comId = selecionados.filter(c => c.id != null && c.id > 0);
    const idsParaRemover = new Set(selecionados.map(c => c.idcliente));

    this.clientesCampanha = this.clientesCampanha.filter(c => !idsParaRemover.has(c.idcliente));
    this.clientesCampanhaSelecionados.clear();

    if (comId.length === 0) {
      this.toastr.success('', selecionados.length + ' cliente(s) removido(s) da campanha.');
      return;
    }

    const deletes = comId.map(c => this.produtoService.deleteProdutoCampanhaClienteById(c.id));
    forkJoin(deletes).subscribe(
      () => {
        this.toastr.success('', selecionados.length + ' cliente(s) removido(s) da campanha.');
      },
      () => {
        this.toastr.error('', 'Erro ao remover alguns clientes da campanha.');
      }
    );
  }

  alterarFiltroVendedorSelecionado() {
    this.formFiltroVendedor.controls['valor'].setValue('');
  }

  adicionarFiltroVendedor() {
    this.enviadoVendedor = true;

    if (this.formFiltroVendedor.invalid) {
      return;
    }

    this.adicionarFiltro(this.filtrosAtivosVendedores, this.formFiltroVendedor.controls['filtro'].value, this.formFiltroVendedor.controls['valor'].value);
    this.formFiltroVendedor.controls['valor'].setValue('');
    this.enviadoVendedor = false;
  }

  removerFiltroVendedor(index: number) {
    this.filtrosAtivosVendedores.splice(index, 1);
    this.filtrosAtivosVendedores = [...this.filtrosAtivosVendedores];
  }

  limparTodosFiltrosVendedores() {
    this.filtrosAtivosVendedores = [];
    this.vendedores = [];
    this.filtrandoVendedor = false;
  }

  filtrarVendedor() {
    if (this.filtrosAtivosVendedores.length === 0) {
      this.vendedores = this.vendedoresOriginal.slice(0, 200);
      this.filtrandoVendedor = false;
      return;
    }

    this.vendedores = this.vendedoresOriginal.filter(vendedor => this.verificarVendedorFiltros(vendedor));
    this.filtrandoVendedor = true;
  }

  obterTextoFiltroVendedor(tipo: string): string {
    return this.obterTextoFiltro(this.filtroVendedores, tipo);
  }

  private verificarVendedorFiltros(vendedor: Vendedor): boolean {
    for (let i = 0; i < this.filtrosAtivosVendedores.length; i++) {
      const filtro = this.filtrosAtivosVendedores[i];
      const valor = filtro.valor.toLowerCase();

      if (filtro.tipo === 'codigo' && !this.textoContem(vendedor.codigo_no_erp_do_cliente, valor)) { return false; }
      if (filtro.tipo === 'nome' && !this.textoContem(vendedor.fullname, valor)) { return false; }
      if (filtro.tipo === 'empresa' && !this.textoContem(vendedor.nm_empresa, valor)) { return false; }
      if (filtro.tipo === 'equipe' && !this.textoContem(vendedor.nome_equipe, valor)) { return false; }
    }

    return true;
  }

  selecionarVendedorBusca(id_vendedor: number) {
    if (this.vendedoresSelecionadosBusca.has(id_vendedor)) {
      this.vendedoresSelecionadosBusca.delete(id_vendedor);
    } else {
      this.vendedoresSelecionadosBusca.add(id_vendedor);
    }
  }

  selecionarTodosVendedoresBusca() {
    if (this.vendedores.length > 0 && this.vendedoresSelecionadosBusca.size === this.vendedores.length) {
      this.vendedoresSelecionadosBusca.clear();
      return;
    }

    this.vendedoresSelecionadosBusca.clear();
    for (let i = 0; i < this.vendedores.length; i++) {
      this.vendedoresSelecionadosBusca.add(this.vendedores[i].id);
    }
  }

  estaVendedorSelecionadoBusca(id_vendedor: number): boolean {
    return this.vendedoresSelecionadosBusca.has(id_vendedor);
  }

  estaTodosVendedoresBuscaSelecionados(): boolean {
    return this.vendedores.length > 0 && this.vendedoresSelecionadosBusca.size === this.vendedores.length;
  }

  importarVendedoresSelecionados() {
    if (this.vendedoresSelecionadosBusca.size === 0) {
      this.toastr.error('', 'Nenhum vendedor(a) selecionado(a)!');
      return;
    }

    let adicionados = 0;

    this.vendedoresSelecionadosBusca.forEach((id_vendedor) => {
      const vendedor = this.vendedoresOriginal.find(item => item.id === id_vendedor);

      if (vendedor == null || this.vendedorJaVinculado(id_vendedor)) {
        return;
      }

      const vinculo = new ProdutoCampanhaVendedor();
      vinculo.id_product_campanha = this.produtoCampanha != null ? this.produtoCampanha.id : 0;
      vinculo.idseller = vendedor.id;
      vinculo.fullname = vendedor.fullname;

      this.vendedoresCampanha.push(vinculo);
      adicionados++;
    });

    this.vendedoresCampanha = this.vendedoresCampanha.sort((a, b) => {
      const nomeA = a.fullname == null ? '' : a.fullname.toLowerCase();
      const nomeB = b.fullname == null ? '' : b.fullname.toLowerCase();
      if (nomeA < nomeB) { return -1; }
      if (nomeA > nomeB) { return 1; }
      return 0;
    });

    this.vendedoresSelecionadosBusca.clear();
    this.toastr.success('', adicionados + ' vendedor(a)(s) vinculado(a)(s) localmente à campanha.');
  }

  removerVendedorCampanha(index: number) {
    const vinculo = this.vendedoresCampanha[index];
    if (vinculo == null) {
      return;
    }

    if (vinculo.id != null && vinculo.id > 0) {
      this.produtoService.deleteProdutoCampanhaVendedorById(vinculo.id).subscribe(
        removido => {
          if (removido) {
            this.vendedoresCampanha.splice(index, 1);
            this.vendedoresCampanha = [...this.vendedoresCampanha];
            this.vendedoresCampanhaSelecionados.delete(vinculo.idseller);
            this.toastr.success('', 'Vendedor(a) desvinculado(a) da campanha.');
          }
        }
      );
      return;
    }

    this.vendedoresCampanha.splice(index, 1);
    this.vendedoresCampanha = [...this.vendedoresCampanha];
    this.vendedoresCampanhaSelecionados.delete(vinculo.idseller);
  }

  selecionarVendedorCampanha(idseller: number) {
    if (this.vendedoresCampanhaSelecionados.has(idseller)) {
      this.vendedoresCampanhaSelecionados.delete(idseller);
    } else {
      this.vendedoresCampanhaSelecionados.add(idseller);
    }
  }

  estaVendedorCampanhaSelecionado(idseller: number): boolean {
    return this.vendedoresCampanhaSelecionados.has(idseller);
  }

  estaTodosVendedoresCampanhaSelecionados(): boolean {
    return this.vendedoresCampanha.length > 0 && this.vendedoresCampanhaSelecionados.size === this.vendedoresCampanha.length;
  }

  selecionarTodosVendedoresCampanha() {
    if (this.estaTodosVendedoresCampanhaSelecionados()) {
      this.vendedoresCampanhaSelecionados.clear();
      return;
    }
    this.vendedoresCampanhaSelecionados.clear();
    for (let i = 0; i < this.vendedoresCampanha.length; i++) {
      this.vendedoresCampanhaSelecionados.add(this.vendedoresCampanha[i].idseller);
    }
  }

  removerVendedoresCampanhaEmMassa() {
    if (this.vendedoresCampanhaSelecionados.size === 0) {
      this.toastr.info('', 'Selecione pelo menos um vendedor.');
      return;
    }

    const selecionados = this.vendedoresCampanha.filter(v => this.vendedoresCampanhaSelecionados.has(v.idseller));
    const comId = selecionados.filter(v => v.id != null && v.id > 0);
    const idsParaRemover = new Set(selecionados.map(v => v.idseller));

    this.vendedoresCampanha = this.vendedoresCampanha.filter(v => !idsParaRemover.has(v.idseller));
    this.vendedoresCampanhaSelecionados.clear();

    if (comId.length === 0) {
      this.toastr.success('', selecionados.length + ' vendedor(es) removido(s) da campanha.');
      return;
    }

    const deletes = comId.map(v => this.produtoService.deleteProdutoCampanhaVendedorById(v.id));
    forkJoin(deletes).subscribe(
      () => {
        this.toastr.success('', selecionados.length + ' vendedor(es) removido(s) da campanha.');
      },
      () => {
        this.toastr.error('', 'Erro ao remover alguns vendedores da campanha.');
      }
    );
  }

  salvarProdutoCampanha() {
    this.enviadoProdutoCampanha = true;
    this.validarItens();

    if (this.formProdutoCampanha.invalid) {
      return;
    }

    if (this.produtosCampanhaItens.length === 0) {
      this.toastr.error('', 'Adicione pelo menos um item à campanha.');
      return;
    }

    for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
      const erro = this.validarItemCampanha(this.produtosCampanhaItens[i]);
      if (erro != null) {
        this.toastr.error('', 'Item ' + this.produtosCampanhaItens[i].codigo + ': ' + erro);
        return;
      }
    }

    if (this.produtoCampanhaPrecoBonificacao === 'B' && this.produtoCampanhaBonificacaoSelecionavel) {
      const existeBonificacao = this.produtosCampanhaItens.some(item => item.bonificacao);
      if (!existeBonificacao) {
        this.toastr.error('', 'Adicione pelo menos um item de bonificação.');
        return;
      }
    }

    this.salvandoCampanha();
  }

  private salvandoCampanha() {
    this.salvando = true;
    this.prepararEnviarDados();

    if (this.produtoCampanha != null && this.produtoCampanha.id != null) {
      this.produtoService.updateProdutoCampanha(this.produtoCampanha).subscribe(
        atualizado => {
          if (!atualizado) {
            this.salvando = false;
            return;
          }

          this.persistirItensELinksCampanha(this.produtoCampanha!.id, true);
        },
        () => {
          this.salvando = false;
        }
      );

      return;
    }

    this.produtoService.addProdutoCampanha(this.produtoCampanha as ProdutoCampanha).subscribe(
      idCampanha => {
        if (idCampanha <= 0) {
          this.salvando = false;
          return;
        }

        (this.produtoCampanha as ProdutoCampanha).id = idCampanha;
        this.persistirItensELinksCampanha(idCampanha, false);
      },
      () => {
        this.salvando = false;
      }
    );
  }

  private persistirItensELinksCampanha(idCampanha: number, alteracao: boolean) {
    for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
      this.produtosCampanhaItens[i].id_campanha = idCampanha;
      this.produtosCampanhaItens[i].tipo = this.mapearTipoUiParaBanco(this.produtosCampanhaItens[i].tipo_calculo) || '';
      this.produtosCampanhaItens[i].dt_inicio = this.dataInicioProdutos || this.normalizarDataParaInput(this.produtosCampanhaItens[i].dt_inicio);
      this.produtosCampanhaItens[i].dt_fim = this.dataFimProdutos || this.normalizarDataParaInput(this.produtosCampanhaItens[i].dt_fim);
    }

    this.produtoService.updateProdutoCampanhaItens(idCampanha, this.produtosCampanhaItens).subscribe(
      atualizado => {
        if (!atualizado) {
          this.salvando = false;
          this.toastr.error('', 'Não foi possível salvar os itens da campanha.');
          return;
        }

        if (!this.usaPromocao) {
          this.finalizarSalvarCampanha(alteracao);
          return;
        }

        this.persistirClientesCampanha(idCampanha).subscribe(
          () => {
            this.persistirVendedoresCampanha(idCampanha).subscribe(
              () => {
                this.finalizarSalvarCampanha(alteracao);
              },
              () => {
                this.salvando = false;
                this.toastr.warning('', 'Campanha salva, mas houve erro ao vincular vendedores.');
              }
            );
          },
          () => {
            this.salvando = false;
            this.toastr.warning('', 'Campanha salva, mas houve erro ao vincular clientes.');
          }
        );
      },
      () => {
        this.salvando = false;
      }
    );
  }

  private persistirClientesCampanha(idCampanha: number): Observable<void> {
    const pendentes = this.clientesCampanha.filter(item => item.id == null || item.id === 0);

    if (pendentes.length === 0) {
      return of(void 0);
    }

    return from(pendentes).pipe(
      concatMap(cliente => {
        cliente.id_product_campanha = idCampanha;
        return this.produtoService.addProdutoCampanhaCliente(cliente).pipe(
          tap(idRetornado => cliente.id = idRetornado)
        );
      }),
      toArray(),
      map(() => void 0)
    );
  }

  private persistirVendedoresCampanha(idCampanha: number): Observable<void> {
    const pendentes = this.vendedoresCampanha.filter(item => item.id == null || item.id === 0);

    if (pendentes.length === 0) {
      return of(void 0);
    }

    return from(pendentes).pipe(
      concatMap(vendedor => {
        vendedor.id_product_campanha = idCampanha;
        return this.produtoService.addProdutoCampanhaVendedor(vendedor).pipe(
          tap(idRetornado => vendedor.id = idRetornado)
        );
      }),
      toArray(),
      map(() => void 0)
    );
  }

  private finalizarSalvarCampanha(alteracao: boolean) {
    this.salvando = false;
    this.toastr.success('', alteracao ? 'Campanha alterada com sucesso!' : 'Campanha adicionada com sucesso!');
    this.router.navigate(['/produtos']);
  }

  prepararEnviarDados() {
    if (this.produtoCampanha == null) {
      this.produtoCampanha = new ProdutoCampanha();
      this.produtoCampanha.guidclientenapis = this.guidclientenapis;
    }

    const qtdeMinima = this.formProdutoCampanha.controls['qtde'].value == null || this.formProdutoCampanha.controls['qtde'].value === ''
      ? 0
      : Number(this.formProdutoCampanha.controls['qtde'].value);

    this.produtoCampanha.nome = String(this.formProdutoCampanha.controls['nome'].value || '').toUpperCase();
    this.produtoCampanha.kit_combo = this.produtoCampanhaKitCombo;
    this.produtoCampanha.is_active = this.produtoCampanhaAtivo;
    this.produtoCampanha.preco_bonificacao = this.produtoCampanhaPrecoBonificacao;
    this.produtoCampanha.qtde_minima = qtdeMinima;
    this.produtoCampanha.imagem = this.campanhaImagem === '' ? '' : this.campanhaImagem.replace('data:image/png;base64,', '');
    this.produtoCampanha.bonificacao_multiplicavel = this.produtoCampanhaBonificacaoMultiplicavel;
    this.produtoCampanha.bonificacao_selecionavel = this.produtoCampanhaBonificacaoSelecionavel;
    this.produtoCampanha.id_no_erp_do_cliente = this.formProdutoCampanha.controls['id_no_erp_do_cliente'].value || null;
  }

  modalSelecionarLote(content: any, id_produto: number) {
    if (this.produtoSelecionado == null) {
      return;
    }

    this.produtoService.getProdutoLoteByIdProduto(id_produto, this.obs_gerais, 0, 0).subscribe(
      produtosLotes => this.produtosLotes = produtosLotes,
      error => {
        console.log('Erro: ' + error);
      },
      () => {
        this.modalReferenciaSelecionarLote = this.modalService.open(content, {
          ariaLabelledBy: 'titulo-selecionar-lote',
          size: 'lg',
          backdrop: 'static'
        });
      }
    );
  }

  selecionarLoteProduto(id_lote: number) {
    if (this.produtoSelecionado == null) {
      return;
    }

    const produtoLote = this.produtosLotes.find(item => item.id === id_lote);
    if (produtoLote == null) {
      return;
    }

    this.produtoSelecionado.valor = produtoLote.preco;
    this.produtoSelecionado.id_lote = produtoLote.id;
    this.produtoSelecionado.nome_lote = produtoLote.nomelote;
    this.produtoSelecionado.cod_lote = produtoLote.codlote;
    this.produtoSelecionado.estoque_lote = produtoLote.estoque;
    this.produtoSelecionado.validade_lote = produtoLote.validade;
    this.produtoSelecionado.preco_lote = produtoLote.preco;
    this.produtoLoteErro = false;

    this.formProdutoCampanhaItem.controls['preco'].setValue(produtoLote.preco);

    if (this.modalReferenciaSelecionarLote != null) {
      this.modalReferenciaSelecionarLote.close();
    }
  }

  removerLoteProduto() {
    if (this.produtoSelecionado == null) {
      return;
    }

    this.produtoSelecionado.id_lote = 0;
    this.produtoSelecionado.nome_lote = '';
    this.produtoSelecionado.cod_lote = '';
    this.produtoSelecionado.estoque_lote = 0;
    this.produtoSelecionado.validade_lote = new Date();
    this.produtoSelecionado.preco_lote = 0;
  }

  converterCampanhaImagem(imagem: any) {
    this.campanhaImagem = 'data:image/png;base64,' + btoa(imagem.target.result);
  }

  removerCampanhaImagem() {
    if (this.arquivoImagem != null && this.arquivoImagem.nativeElement != null) {
      this.arquivoImagem.nativeElement.value = '';
    }

    this.campanhaImagem = '';
  }

  uploadCampanhaImagem(imagem_campanha: any) {
    if (imagem_campanha == null || imagem_campanha.target.files.length === 0) {
      return;
    }

    if (imagem_campanha.target.accept !== imagem_campanha.target.files[0].type) {
      this.campanhaImagemErro = false;
      this.campanhaImagemInvalida = true;
      this.removerCampanhaImagem();
      return;
    }

    const arquivo = imagem_campanha.target.files[0];
    const tamanho = (arquivo.size / (1024 * 1024));

    if (tamanho > 0.06) {
      this.campanhaImagemErro = true;
      this.campanhaImagemInvalida = false;
      this.removerCampanhaImagem();
      return;
    }

    this.campanhaImagemErro = false;
    this.campanhaImagemInvalida = false;

    const reader = new FileReader();
    reader.onload = this.converterCampanhaImagem.bind(this);
    reader.readAsBinaryString(arquivo);
  }

  decrementarQtdeProduto() {
    if (this.produtoSelecionado == null) {
      return;
    }

    let qtde = this.formProdutoCampanhaItem.controls['qtde'].value;
    if (qtde == null || qtde <= 1) {
      this.formProdutoCampanhaItem.controls['qtde'].setValue(null);
      return;
    }

    this.formProdutoCampanhaItem.controls['qtde'].setValue(Number(qtde) - 1);
  }

  incrementarQtdeProduto() {
    if (this.produtoSelecionado == null) {
      return;
    }

    let qtde = this.formProdutoCampanhaItem.controls['qtde'].value;
    if (qtde == null || qtde <= 0) {
      this.formProdutoCampanhaItem.controls['qtde'].setValue(1);
      return;
    }

    this.formProdutoCampanhaItem.controls['qtde'].setValue(Number(qtde) + 1);
  }

  private adicionarFiltro(lista: FiltroAtivo[], tipo: string, valor: string) {
    const valorTexto = String(valor || '').trim();
    if (valorTexto === '') {
      return;
    }

    const existe = lista.some(item => item.tipo === tipo && String(item.valor).toLowerCase() === valorTexto.toLowerCase());
    if (existe) {
      return;
    }

    lista.push({ tipo: tipo, valor: valorTexto });
  }

  private obterTextoFiltro(lista: any[], tipo: string): string {
    const filtro = lista.find(item => item.valor === tipo);
    return filtro != null ? filtro.texto : tipo;
  }

  private textoContem(campo: any, valor: string): boolean {
    if (campo == null) {
      return false;
    }

    return String(campo).toLowerCase().indexOf(valor) !== -1;
  }

  private existeItemDuplicado(item: ProdutoCampanhaItens): boolean {
    return this.localizarIndiceDuplicado(item) !== -1;
  }

  private localizarIndiceDuplicado(item: ProdutoCampanhaItens): number {
    for (let i = 0; i < this.produtosCampanhaItens.length; i++) {
      if (this.obterAssinaturaItem(this.produtosCampanhaItens[i]) === this.obterAssinaturaItem(item)) {
        return i;
      }
    }

    return -1;
  }

  private obterAssinaturaItem(item: ProdutoCampanhaItens): string {
    return [item.product_id || item.codigo, item.bonificacao ? '1' : '0', item.id_lote || 0, Number(item.qtdade) || 0].join('|');
  }

  private obterChaveItemCampanha(item: ProdutoCampanhaItens, index: number): string {
    if (item.id != null && item.id > 0) {
      return 'id-' + item.id;
    }

    return this.obterAssinaturaItem(item) + '|' + index;
  }

  private validarItemCampanha(item: ProdutoCampanhaItens): string | null {
    if (item == null || item.product_id == null || item.product_id === 0) {
      return 'Produto inválido.';
    }

    if (this.validarPeriodo(item.dt_inicio, item.dt_fim)) {
      return 'Data inicial maior que a data final.';
    }

    if (item.qtdade == null || Number(item.qtdade) < 0) {
      return 'Quantidade inválida.';
    }

    if (!item.bonificacao && (item.preco == null || Number(item.preco) <= 0)) {
      return 'Preço deve ser maior que zero.';
    }

    if (item.tipo_calculo != null && item.tipo_calculo !== '') {
      if (item.tipo_percentual == null || isNaN(Number(item.tipo_percentual))) {
        return 'Informe um percentual válido.';
      }

      if (item.tipo_calculo === 'desconto' && Number(item.tipo_percentual) >= 100) {
        return 'Desconto não pode ser maior ou igual a 100%.';
      }
    }

    return null;
  }

  private validarPeriodo(dt_inicio: any, dt_fim: any): boolean {
    if (dt_inicio == null || dt_inicio === '' || dt_fim == null || dt_fim === '') {
      return false;
    }

    const inicio = new Date(dt_inicio);
    const fim = new Date(dt_fim);
    return inicio.getTime() > fim.getTime();
  }

  private normalizarDataParaInput(data: any): string {
    if (data == null || data === '') {
      return '';
    }

    if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
      return data;
    }

    if (typeof data === 'number') {
      const parsedExcel = XLSX.SSF.parse_date_code(data);
      if (parsedExcel != null) {
        return parsedExcel.y + '-' + String(parsedExcel.m).padStart(2, '0') + '-' + String(parsedExcel.d).padStart(2, '0');
      }
    }

    const date = data instanceof Date ? data : new Date(data);
    if (isNaN(date.getTime())) {
      return '';
    }

    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }

  private normalizarDataPlanilha(data: any): string {
    return this.normalizarDataParaInput(data);
  }

  private normalizarNumero(valor: any): number | null {
    if (valor == null || valor === '') {
      return null;
    }

    const texto = String(valor).replace(',', '.');
    const numero = parseFloat(texto);
    return isNaN(numero) ? null : numero;
  }

  private normalizarBoolean(valor: any): boolean {
    if (typeof valor === 'boolean') {
      return valor;
    }

    const texto = String(valor || '').trim().toUpperCase();
    return texto === 'S' || texto === 'SIM' || texto === 'TRUE' || texto === '1';
  }

  private normalizarTipoUi(valor: string): string {
    const texto = String(valor || '').trim().toUpperCase();

    if (texto === 'M' || texto === 'MARGEM') {
      return 'margem';
    }

    if (texto === 'D' || texto === 'DESCONTO') {
      return 'desconto';
    }

    return '';
  }

  private mapearTipoUiParaBanco(tipo: string): string | null {
    if (tipo === 'margem') {
      return 'M';
    }

    if (tipo === 'desconto') {
      return 'D';
    }

    return null;
  }

  private mapearTipoBancoParaUi(tipo: string): string {
    if (tipo === 'M') {
      return 'margem';
    }

    if (tipo === 'D') {
      return 'desconto';
    }

    return '';
  }

  private calcularPrecoPorPercentual(precoBase: number, tipo: string, percentual: number): number | null {
    if (precoBase == null || percentual == null) {
      return null;
    }

    let resultado = precoBase;
    if (tipo === 'margem') {
      resultado = precoBase * (1 + (percentual / 100));
    } else if (tipo === 'desconto') {
      resultado = precoBase * (1 - (percentual / 100));
    }

    return Math.round(resultado * 100) / 100;
  }

  private calcularPercentualPorPreco(precoBase: number, tipo: string, preco: number): number | null {
    if (precoBase == null || preco == null || precoBase <= 0) {
      return null;
    }

    let percentual = 0;
    if (tipo === 'margem') {
      percentual = ((preco / precoBase) - 1) * 100;
    } else if (tipo === 'desconto') {
      percentual = (1 - (preco / precoBase)) * 100;
    }

    return Math.round(percentual * 100) / 100;
  }

  private clienteJaVinculado(id_cliente: number): boolean {
    return this.clientesCampanha.some(item => item.idcliente === id_cliente);
  }

  private vendedorJaVinculado(id_vendedor: number): boolean {
    return this.vendedoresCampanha.some(item => item.idseller === id_vendedor);
  }

  carregarRegrasGrupo() {
    this.regrasGrupoCarregando = true;
    const guid = localStorage.getItem('guidclientenapis');
    this.produtoService.getRegraGrupos(this.produtoCampanha.id, 'campanha', guid).subscribe(r => {
      this.regrasGrupo = r;
      this.regrasGrupoCarregando = false;
    });
  }

  carregarValoresCliente() {
    if (!this.rgCampoCliente) return;
    this.rgValoresCliente = [];
    this.rgValorCliente = '';
    this.rgValoresClienteCarregando = true;
    const guid = localStorage.getItem('guidclientenapis');
    this.produtoService.getValoresDistintos('cliente', this.rgCampoCliente, guid).subscribe(v => {
      this.rgValoresCliente = v;
      this.rgValoresClienteCarregando = false;
    });
  }

  carregarValoresProduto() {
    if (!this.rgCampoProduto) return;
    this.rgValoresProduto = [];
    this.rgValorProduto = '';
    this.rgValoresProdutoCarregando = true;
    const guid = localStorage.getItem('guidclientenapis');
    this.produtoService.getValoresDistintos('produto', this.rgCampoProduto, guid).subscribe(v => {
      this.rgValoresProduto = v;
      this.rgValoresProdutoCarregando = false;
    });
  }

  adicionarRegraGrupoCliente() {
    if (!this.rgCampoCliente || !this.rgValorCliente) return;
    if (this.regrasGrupoClientes.some(r => r.campo === this.rgCampoCliente && r.valor === this.rgValorCliente)) {
      this.toastr.warning('', 'Essa regra já foi adicionada.');
      return;
    }
    const regra = new PromoRegraGrupo();
    regra.promo_id = this.produtoCampanha.id;
    regra.promo_tipo = 'campanha';
    regra.entidade = 'cliente';
    regra.campo = this.rgCampoCliente;
    regra.valor = this.rgValorCliente;
    regra.guidclientenapis = localStorage.getItem('guidclientenapis');
    this.produtoService.addRegraGrupo(regra).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Regra de cliente adicionada!');
        this.rgCampoCliente = '';
        this.rgValorCliente = '';
        this.rgValoresCliente = [];
        this.carregarRegrasGrupo();
      } else {
        this.toastr.error('', 'Erro ao adicionar regra.');
      }
    });
  }

  adicionarRegraGrupoProduto() {
    if (!this.rgCampoProduto || !this.rgValorProduto || !this.rgQtdProduto || !this.rgTipoProduto || this.rgPercentualProduto == null) return;
    if (this.regrasGrupoProdutos.some(r => r.campo === this.rgCampoProduto && r.valor === this.rgValorProduto)) {
      this.toastr.warning('', 'Essa regra já foi adicionada.');
      return;
    }
    const regra = new PromoRegraGrupo();
    regra.promo_id    = this.produtoCampanha.id;
    regra.promo_tipo  = 'campanha';
    regra.entidade    = 'produto';
    regra.campo       = this.rgCampoProduto;
    regra.valor       = this.rgValorProduto;
    regra.qtd         = this.rgQtdProduto;
    regra.tipo_preco  = this.rgTipoProduto;
    regra.percentual  = this.rgPercentualProduto;
    regra.guidclientenapis = localStorage.getItem('guidclientenapis');
    this.produtoService.addRegraGrupo(regra).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Regra de produto adicionada!');
        this.rgCampoProduto       = '';
        this.rgValorProduto       = '';
        this.rgValoresProduto     = [];
        this.rgQtdProduto         = null;
        this.rgTipoProduto        = '';
        this.rgPercentualProduto  = null;
        this.carregarRegrasGrupo();
      } else {
        this.toastr.error('', 'Erro ao adicionar regra.');
      }
    });
  }

  removerRegraGrupo(id: number) {
    this.produtoService.deleteRegraGrupo(id).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Regra removida!');
        this.carregarRegrasGrupo();
      } else {
        this.toastr.error('', 'Erro ao remover regra.');
      }
    });
  }
}
